import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify, {
    options: {
        customProperties: true
    }
})

export default new Vuetify({
    rtl: true,
    iconfont: "mdiSvg",
    customProperties: true,
    treeShake: true,
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#4FB492',
                secondary: '#424242',
                accent: '#FF958A',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107'
            },
        },
    },
});
